export const getAttendanceInitials = (attendanceName: string) => {
  const nameParts = attendanceName.split(" ");

  return nameParts.length === 1
    ? nameParts[0].charAt(0).toUpperCase()
    : nameParts[0].charAt(0).toUpperCase() +
        nameParts[nameParts.length - 1].charAt(0).toUpperCase();
};
